import { AccountingPlatform, AccountingPlatformSlug, BillLineItem, PostBillsRequest } from '@melio/platform-api';

type Payload = {
  vendorId: string;
  categoryId?: string;
  amount: number;
  today: Date;
  invoiceNumber?: string;
};

export const createPayloadByAccountingSoftware = (
  payload: Payload,
  activeAccountingPlatform?: AccountingPlatform
): PostBillsRequest => {
  if (activeAccountingPlatform?.accountingSlug === AccountingPlatformSlug.Xero) {
    return {
      amount: payload.amount,
      dueDate: payload.today.toISOString(),
      vendorId: payload.vendorId,
      invoice: { number: payload.invoiceNumber },
      note: '',
      lineItems: [
        {
          type: 'category',
          amount: payload.amount,
          order: 1,
          quantity: 1,
          unitPrice: payload.amount,
          externalCategoryId: payload.categoryId || null,
          description: null,
        } as BillLineItem,
      ],
    };
  }
  return {
    amount: payload.amount,
    dueDate: payload.today.toISOString(),
    vendorId: payload.vendorId,
    invoice: { number: payload.invoiceNumber },
    note: '',
    lineItems: [
      {
        type: 'category',
        amount: payload.amount,
        order: 1,
        externalCategoryId: payload.categoryId || null,
        description: null,
      },
    ],
  };
};
